var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b360-label-holder",class:{ 'visually-hidden': _vm.hidden }},[_c('label',{staticClass:"b360-form-label",class:{
			'remove-margin--bottom': _vm.isComplianceLogo,
			'no-bottom-margin': _vm.isChangeContactType,
		},attrs:{"data-test":"form-label","for":_vm.name}},[_vm._v(_vm._s(_vm.label)+"\n\t\t"),(_vm.required)?_c('font-awesome-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
				content: 'This is a required field',
				trigger: 'hover click',
				placement: 'top-end',
			}),expression:"{\n\t\t\t\tcontent: 'This is a required field',\n\t\t\t\ttrigger: 'hover click',\n\t\t\t\tplacement: 'top-end',\n\t\t\t}"}],staticClass:"asterisk",attrs:{"icon":['fas', 'asterisk']}}):_vm._e()],1),(_vm.tooltip)?_c('font-awesome-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
			content: _vm.tooltip,
			trigger: 'hover click',
			placement: 'top-end',
		}),expression:"{\n\t\t\tcontent: tooltip,\n\t\t\ttrigger: 'hover click',\n\t\t\tplacement: 'top-end',\n\t\t}"}],staticClass:"tooltip-target b360-form-icon",attrs:{"icon":['fal', 'question-circle']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }